/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import { ROLES, ROUTE_NAMES } from 'routes';
import { accountActions, globalActions } from '_actions';
import { Loading } from '_components';
import CrAlert from '_components/CrAlert';
// routes config
import {
  selectorGetCurrentUserAccountID,
  selectorGetCurrentUserRole
} from '_selectors/auth.selectors';
import { selectGlobalAccountID } from '_selectors/global.selectors';
import session from '../../_helpers/session';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import DefaultSidebar from './DefaultSidebar';

function DefaultLayout(props) {
  const { loggedIn, mainClass, route } = props;
  const {
    match: {
      params: { accountID },
    },
  } = props;
  const routeName = route?.name;

  // Action dispatcher
  const dispatch = useDispatch();

  const myAccountID = useSelector(selectorGetCurrentUserAccountID);
  const role = useSelector(selectorGetCurrentUserRole);
  const globalAccountID = useSelector(selectGlobalAccountID);
  const childProps = { ...props, accountID: globalAccountID, myAccountID };

  // NOTE: Move these loaders to the hook
  const [ loading, setLoading ] = useState(false);

  // NOTE: This populates the account store instead of the legacy global
  // NOTE: Should be replaced with hook
  useEffect(() => {
    (async () => {
      if (!myAccountID || !loggedIn) {
        // We don't want to force a redirect if they're on the homepage
        if (routeName === ROUTE_NAMES.HOME) {
          return;
        }

        await session.userManager.signinRedirect();
      }
    })();
  }, [ dispatch, loggedIn, myAccountID, routeName ]);

  useEffect(() => {
    let currentAccount;
    if (!globalAccountID) {
      currentAccount = +myAccountID;
    } else if (Number(globalAccountID) !== Number(accountID) && accountID) {
      currentAccount = +accountID; // From parent props
    }
    if (currentAccount) {
      (async () => {
        setLoading(true);
        if (role === ROLES.SUPPORT) {
          await dispatch(globalActions.getAccounts());
        } else {
          await dispatch(accountActions.getAccount(currentAccount));
        }
        // Set current selected account
        await dispatch(globalActions.setAccount(currentAccount));
        setLoading(false);
      })();
    }
  }, [ dispatch, accountID, globalAccountID, myAccountID, role ]);

  if (loading) {
    return <Loading />;
  }

  return (
    // NOTE The "!route.role" is meant to allow externals to see specific pages
    // We should probably create a new role or create a specific view for
    // sharing data to externals
    <>
      {loggedIn && <DefaultHeader />}
      <div className='app-body'>
        {loggedIn && <DefaultSidebar {...childProps} />}
        <main className={`main ${mainClass}`}>
          <Container fluid>
            <CrAlert />
            <route.component {...childProps} />
          </Container>
        </main>
      </div>
      {loggedIn && (
        <div className={`app-footer ${mainClass}`}>
          <DefaultFooter />
        </div>
      )}
    </>
  );
}

export default DefaultLayout;
